export default __webpack_public_path__ + "static/media/psychic.67439878.svg";